import React from "react";
import { Link } from "react-router-dom";

const Shared04Logo = ({ options }) => {
  //Des
  const { logo, logo_link, aria_label, logo_alt } = options;

  return (
    <div className="main-logo">
      <Link to={logo_link} aria-label={aria_label}>
        <img src={logo} alt={logo_alt} />
      </Link>
    </div>
  );
};

export default Shared04Logo;
